import Editor from "../components/Editor";
import RequestsList from "../components/requests-list/RequestsList";
import {useContext, useEffect, useRef, useState} from "react";
import {Input} from "antd";
import RectangleLeftThirdFilled from "../icons/RectangleLeftThirdFilled";
import RectangleRightThirdFilled from "../icons/RectangleRightThirdFilled";
import RectangleCenterThirdFilled from "../icons/RectangleCenterThirdFilled";
import MainMenuBar from "../components/MainMenuBar";
import {appContext} from "../state";
import Clone from "../utils/clone";
import NavigationBarVertial from "../components/NavigationBarVertical";
import Home from "./Home";
import Settings from "./Settings";
import AppLocalStorage from "../storage/localStorage";
import PlayGround from "./Playground";
import Profile from "./Profile";
import {useLocation, useNavigate} from "react-router-dom";

function Main(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState)
    const location = useLocation();
    const navigate = useNavigate();
    const { hash, pathname, search } = location;

    useEffect(() => {
       // console.log('UPDATE_APP_STATE_REF',appState,"TRIGGER:",appStateRef.current.trigger)
        appStateRef.current = appState
        AppLocalStorage.save(appState)
        if (process.env.NODE_ENV !== 'production') {
            window.app.appState = appState
            window.app.exposeAppState = () => {
                return JSON.stringify(window.app.appState)
            }
        }
    },[appState]);

    function onNavBarTabClick (e) {
        console.log('CHANGE_VIEW',e.key)
        /*let newAppState = Clone(appStateRef.current)
        newAppState.view = e.key
        setAppState(newAppState)*/
        navigate(e.key)
    }

    function pathsWithVerticalTabBar (pathname) {
        return ['/',"/settings"].includes(pathname)
    }

    function pathsWitMainMenubar (pathname) {
        return ['/',"/settings"].includes(pathname)
    }

    return (
        <div data-test={appState.menuBarButtons.left} className="main">
            {pathsWitMainMenubar(pathname) ? <MainMenuBar key={"main-menu-bar-"+appState.mockAPI} mockAPI={appState.mockAPI} targetAPI={appState.targetAPI}></MainMenuBar> : false}
            <div data-view={appState.view} className="content">
                {pathsWithVerticalTabBar(pathname) ? <NavigationBarVertial view={appState.view} onNavBarTabClick={onNavBarTabClick}></NavigationBarVertial> : false}
                {props.children}
            </div>
        </div>
    );
}

export default Main;
